@if (filterMenus) {
  <div class="filter-menus">
    @for (item of filterMenus.items; track item) {
      <div>
        <filter-menu [filterMenu]="item" (clicked)="menuClick($event)" (hasLoaded)="menusLoaded()"></filter-menu>
      </div>
    }
  </div>
}